if (!customElements.get('eyv-holster-finder')) {
  customElements.define(
    'eyv-holster-finder',
    class EYVHolsterFinder extends HTMLElement {
      constructor() {
        super();
        this.catalog = Array.isArray(window.EYV_HOLSTER_CATALOG) ? window.EYV_HOLSTER_CATALOG : [];
        this.state = {
          gun: '',
          gunProducts: [],
          light: '',
          lightLabel: '',
          style: 'all',
          collection: 'all',
          history: [],
        };
        this.chatState = {
          gun: '',
          gunProducts: [],
          light: null,
          lightLabel: '',
          style: 'all',
        };
        this.guns = this.buildGunIndex();
      }

      connectedCallback() {
        this.gunInput = this.querySelector('[name="firearm"]');
        this.lightInput = this.querySelector('[name="weapon-light"]');
        this.gunSuggestions = this.querySelector('[id^="EYV-Gun-Suggestions"]');
        this.lightSuggestions = this.querySelector('[id^="EYV-Light-Suggestions"]');
        this.notice = this.querySelector('.eyv-finder__notice');
        this.chatLog = this.querySelector('[data-chat-log]');
        this.chatOptions = this.querySelector('[data-chat-options]');
        this.chatForm = this.querySelector('[data-chat-form]');
        this.chatInput = this.querySelector('[name="eyv-chat-message"]');
        this.guideGunInput = this.querySelector('[name="eyv-guided-firearm"]');
        this.guideGunSuggestions = this.querySelector('[data-guide-gun-suggestions]');
        this.bindEvents();
        this.renderGunSuggestions('');
        this.restoreResultsState();
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const productLink = event.target.closest('[data-eyv-product-link]');
          if (productLink) this.saveResultsState();

          const target = event.target.closest('[data-action]');
          if (!target) return;
          const action = target.dataset.action;
          if (action === 'switch-mode') this.switchMode(target.dataset.mode);
          if (action === 'select-gun') this.selectGun(target.dataset.value);
          if (action === 'confirm-gun') this.confirmGun();
          if (action === 'light-no') this.selectNoLight();
          if (action === 'light-yes') this.showLightStep();
          if (action === 'select-light') this.selectLight(target.dataset.value, target.dataset.label);
          if (action === 'confirm-light') this.confirmLight();
          if (action === 'style') this.showResults(target.dataset.style);
          if (action === 'back') this.goBack();
          if (action === 'results-back') this.returnToChat(false);
          if (action === 'restart') this.restart();
          if (action === 'chat-select-gun') this.chatSelectGun(target.dataset.value);
          if (action === 'chat-light') this.chatSelectLight(target.dataset.value, target.dataset.label);
          if (action === 'chat-show-results') this.chatShowResults();
          if (action === 'chat-restart') this.chatRestart();
          if (action === 'chat-prompt') {
            const message = target.dataset.value;
            this.addChatMessage('user', message);
            this.querySelector('[data-starter-prompts]').classList.add('is-hidden');
            this.processChatMessage(message);
          }
          if (action === 'guide-select-gun') this.guideSelectGun(target.dataset.value);
          if (action === 'guide-confirm-gun') this.guideConfirmGun();
          if (action === 'guide-no-light') this.guideSelectNoLight();
          if (action === 'guide-show-lights') this.guideShowLights();
          if (action === 'guide-select-light') this.guideSelectLight(target.dataset.value, target.dataset.label);
          if (action === 'guide-style') this.guideShowResults(target.dataset.style);
          if (action === 'guide-back') this.showGuideStep(target.dataset.target);
          if (action === 'toggle-complete-entry') {
            const entry = this.querySelector('[data-complete-entry]');
            entry.hidden = !entry.hidden;
            target.setAttribute('aria-expanded', String(!entry.hidden));
            if (!entry.hidden) this.chatInput.focus();
          }
        });

        this.chatForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const message = this.chatInput.value.trim();
          if (!message) return;
          this.addChatMessage('user', message);
          this.querySelector('[data-starter-prompts]').classList.add('is-hidden');
          this.chatInput.value = '';
          this.processChatMessage(message);
        });

        this.guideGunInput.addEventListener('input', () => {
          this.chatState.gun = '';
          this.chatState.gunProducts = [];
          this.querySelector('[data-action="guide-confirm-gun"]').disabled = this.guideGunInput.value.trim().length < 2;
          const error = this.querySelector('[data-guide-gun-error]');
          error.hidden = true;
          error.textContent = '';
        });
        this.guideGunInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (!this.querySelector('[data-action="guide-confirm-gun"]').disabled) this.guideConfirmGun();
          }
        });

        this.gunInput.addEventListener('input', () => {
          this.state.gun = '';
          this.state.gunProducts = [];
          this.querySelector('[data-action="confirm-gun"]').disabled = true;
          this.renderGunSuggestions(this.gunInput.value);
        });

        this.gunInput.addEventListener('focus', () => this.renderGunSuggestions(this.gunInput.value));
        this.gunInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            const first = this.gunSuggestions.querySelector('[data-action="select-gun"]');
            if (first) first.click();
          }
        });

        this.lightInput.addEventListener('input', () => {
          this.state.light = '';
          this.state.lightLabel = '';
          this.querySelector('[data-action="confirm-light"]').disabled = true;
          this.renderLightSuggestions(this.lightInput.value);
        });

        this.lightInput.addEventListener('focus', () => this.renderLightSuggestions(this.lightInput.value));
        this.lightInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            const first = this.lightSuggestions.querySelector('[data-action="select-light"]');
            if (first) first.click();
          }
        });

        this.querySelector('[data-collection-filter]').addEventListener('change', (event) => {
          this.state.collection = event.target.value;
          this.renderResults();
        });
        this.querySelectorAll('[data-collection-choice]').forEach((button) => {
  button.addEventListener('click', () => {
    const collection = button.dataset.collectionChoice;

    this.state.collection = collection;
    this.querySelector('[data-collection-filter]').value = collection;

    this.querySelectorAll('[data-collection-choice]').forEach((choice) => {
      choice.classList.toggle(
        'is-selected',
        choice.dataset.collectionChoice === collection
      );
    });

    this.renderResults();

    const results = this.querySelector('[data-results]');
    if (results) {
      results.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.closeSuggestions();
          }
        });
      }

      normalize(value) {
        let normalized = String(value || '')
          .toLowerCase()
          .replace(/\bm\s*&\s*p\b/g, 'mp')
          .replace(/\bheckler\s*(?:&|and)?\s*koch\b/g, 'hk')
          .replace(/\bh\s*&\s*k\b/g, 'hk')
          .replace(/&/g, ' and ')
          .replace(/\bsmith\s+(?:and\s+)?wesson\b/g, 'sw')
          .replace(/\bs\s+and\s+w\b/g, 'sw')
          .replace(/\bh\s+(?:and\s+)?k\b/g, 'hk')
          .replace(/\bheckler\b/g, 'hk')
          .replace(/\bsmith\b/g, 'sw')
          .replace(/\bhk\s+and\b/g, 'hk')
          .replace(/\bsw\s+and\b/g, 'sw')
          .replace(/\bspringfield armory\b/g, 'sa')
          .replace(/\bspringfield\b/g, 'sa')
          .replace(/\bsig sauer\b/g, 'sig')
          .replace(/\bstreamlight\b/g, '')
          .replace(/\bsurefire\b/g, 'sure fire')
          .replace(/\bt\s*\.?\s*o\s*\.?\s*r\s*\.?\s*o\.?/g, 'toro')
          .replace(/\bwith\b/g, ' ')
          .replace(/\blight\b/g, ' ')
          .replace(/[^a-z0-9]+/g, ' ')
          .replace(/\b(?!fn\s)([a-z]{1,4})\s+(\d+[a-z]*)\b/g, '$1$2')
          .replace(/\bp\s+(\d+)\s*(xl|x)?\b/g, 'p$1$2')
          .replace(/\bp(\d+)\s+(xl|x)\b/g, 'p$1$2')
          .replace(/\s+/g, ' ')
          .trim();
        if (/^(?:hellcat|prodigy|xd|xds|xdm)\b/.test(normalized)) normalized = `sa ${normalized}`;
        if (/^(?:mp|shield|bodyguard)\b/.test(normalized)) normalized = `sw ${normalized}`;
        return normalized;
      }

      compact(value) {
        return this.normalize(value).replace(/\s+/g, '');
      }

      modelTokens(value) {
        const withoutGenerations = String(value || '')
          .toLowerCase()
          .replace(/\bgen(?:eration)?s?\s*\d+(?:\s*[-–]\s*\d+)?/g, ' ')
          .replace(/\b(?:9mm|40sw|45acp|380acp)\b/g, ' ');
        const tokens = withoutGenerations.match(/\b[a-z]*\d+[a-z]*\b/g) || [];

        // Expand shorthand model families such as P365/X/XL into
        // P365, P365X and P365XL without treating unrelated prefixes as equal.
        const slashFamilies = withoutGenerations.matchAll(/\b([a-z]+\d+)\s*\/\s*([a-z]+)(?:\s*\/\s*([a-z]+))?/g);
        for (const family of slashFamilies) {
          tokens.push(family[1], `${family[1]}${family[2]}`);
          if (family[3]) tokens.push(`${family[1]}${family[3]}`);
        }

        // Macro is a distinct configuration, not a fuzzy extension of P365.
        if (/\bp365\s*x?\s*macro\b/.test(withoutGenerations)) tokens.push('p365xmacro');
        if (/\bp365x\s*macro\b/.test(withoutGenerations)) tokens.push('p365xmacro');

        return [...new Set(tokens.filter((token) => token.length > 1))];
      }

      brandToken(value) {
        const normalized = this.normalize(value);
        const brands = [
          ['glock', /\bglock\b/],
          ['sig', /\bsig\b/],
          ['sw', /\bsw\b/],
          ['springfield', /\b(?:sa|springfield)\b/],
          ['ruger', /\bruger\b/],
          ['taurus', /\btaurus\b/],
          ['cz', /\bcz\b/],
          ['canik', /\bcanik\b/],
          ['kimber', /\bkimber\b/],
          ['hk', /\b(?:h&k|hk)\b/],
          ['fn', /\bfn\b/],
          ['walther', /\bwalther\b/],
          ['beretta', /\bberetta\b/],
          ['colt', /\bcolt\b/],
          ['kahr', /\bkahr\b/],
        ];
        const match = brands.find(([, pattern]) => pattern.test(normalized));
        return match ? match[0] : '';
      }

      modelsAreCompatible(query, candidate) {
        const queryBrand = this.brandToken(query);
        const candidateBrand = this.brandToken(candidate);
        if (queryBrand && candidateBrand && queryBrand !== candidateBrand) return false;

        const queryWords = new Set(this.normalize(query).split(' '));
        const candidateWords = new Set(this.normalize(candidate).split(' '));
        const requiredQualifiers = ['macro', 'plus', 'pro', 'rdp', 'compact', 'carry', 'mos', 'osp'];
        if (requiredQualifiers.some((qualifier) => queryWords.has(qualifier) && !candidateWords.has(qualifier))) {
          return false;
        }
        const queryModels = [...new Set(this.aliases(query).flatMap((value) => this.modelTokens(value)))];
        const candidateModels = this.modelTokens(candidate);
        if (!queryModels.length || !candidateModels.length) return true;
        return queryModels.some((queryModel) =>
          candidateModels.some(
            (candidateModel) => candidateModel === queryModel || candidateModel.startsWith(queryModel)
          )
        );
      }

      aliases(value) {
        const normalized = this.normalize(value);
        const values = new Set([normalized]);
        const replacements = [
          [/\bg(\d{2})\b/g, 'glock $1'],
          [/\bp365 macro\b/g, 'p365 x macro'],
          [/\b365 macro\b/g, 'p365 x macro'],
          [/\bhellcat pro\b/g, 'sa hellcat pro'],
          [/\bshield plus\b/g, 'm&p shield plus'],
          [/\bmp shield\b/g, 'm&p shield'],
        ];
        replacements.forEach(([pattern, replacement]) => values.add(normalized.replace(pattern, replacement)));
        return [...values].filter(Boolean);
      }

      levenshtein(a, b) {
        if (!a.length) return b.length;
        if (!b.length) return a.length;
        let previous = Array.from({ length: b.length + 1 }, (_, index) => index);
        for (let i = 1; i <= a.length; i += 1) {
          const current = [i];
          for (let j = 1; j <= b.length; j += 1) {
            current[j] = Math.min(
              current[j - 1] + 1,
              previous[j] + 1,
              previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
            );
          }
          previous = current;
        }
        return previous[b.length];
      }

      score(query, candidate) {
        if (!query) return 1;
        const candidateNormalized = this.normalize(candidate);
        const candidateCompact = this.compact(candidate);
        let best = 0;
        this.aliases(query).forEach((queryAlias) => {
          const queryCompact = queryAlias.replace(/\s+/g, '');
          if (candidateNormalized === queryAlias) best = Math.max(best, 1000);
          if (candidateCompact === queryCompact) best = Math.max(best, 980);
          if (candidateNormalized.startsWith(queryAlias)) best = Math.max(best, 900 - candidateNormalized.length);
          if (candidateNormalized.includes(queryAlias)) best = Math.max(best, 820 - candidateNormalized.length);
          const tokens = queryAlias.split(' ').filter(Boolean);
          const matchedTokens = tokens.filter((token) => candidateNormalized.includes(token)).length;
          if (tokens.length && matchedTokens === tokens.length) best = Math.max(best, 720 - candidateNormalized.length);
          const distance = this.levenshtein(queryCompact, candidateCompact);
          const similarity = 1 - distance / Math.max(queryCompact.length, candidateCompact.length, 1);
          if (similarity >= 0.58) best = Math.max(best, Math.round(similarity * 600));
        });
        return best;
      }

      buildGunIndex() {
        const gunMap = new Map();
        this.catalog.forEach((product) => {
          if (!product.g) return;
          const key = this.normalize(product.g);
          if (!gunMap.has(key)) gunMap.set(key, { name: product.g, products: [] });
          gunMap.get(key).products.push(product);
        });
        return [...gunMap.values()];
      }

      namedFamilyToken(value) {
        const normalized = this.normalize(value);
        if (/\bhellcat\b/.test(normalized)) return 'hellcat';
        return '';
      }

      genericFamilySelection(value) {
        const normalized = this.normalize(value);
        if (/^taurus(?: tx22)? toro$/.test(normalized)) {
          return { key: 'taurus-toro', label: 'Taurus TX22 T.O.R.O. family' };
        }
        if (/^cz shadow(?: 2)?$/.test(normalized)) {
          return { key: 'cz-shadow', label: 'CZ Shadow family' };
        }
        if (
          this.namedFamilyToken(value) === 'hellcat' &&
          !/\b(?:rdp|pro|osp)\b/.test(normalized)
        ) {
          return { key: 'hellcat', queryName: 'SA Hellcat', label: 'Springfield Hellcat family' };
        }
        return null;
      }

      productsForGenericFamily(family) {
        if (!family) return [];
        if (family.key === 'cz-shadow') {
          return [
            ...new Map(
              this.catalog
                .filter((product) => /^cz shadow 2\b/.test(this.normalize(product.g)))
                .map((product) => [product.h, product])
            ).values(),
          ];
        }
        if (family.key === 'taurus-toro') {
          return [
            ...new Map(
              this.catalog
                .filter((product) => /^taurus tx22 toro$/.test(this.normalize(product.g)))
                .map((product) => [product.h, product])
            ).values(),
          ];
        }
        return this.productsForGunSelection(family.queryName);
      }

      productsForGunSelection(name) {
        const selected = this.guns.find((gun) => gun.name === name);
        const namedFamily = this.namedFamilyToken(name);
        if (!selected && !namedFamily) return [];
        const selectedProducts = selected ? selected.products : [];
        const selectedBrand = this.brandToken(name);
        if (!this.modelTokens(name).length && !namedFamily) return selectedProducts;

        const products = this.guns
          .filter((gun) => {
            const candidateBrand = this.brandToken(gun.name);
            const familyMatches = !namedFamily || this.namedFamilyToken(gun.name) === namedFamily;
            return (
              (!selectedBrand || candidateBrand === selectedBrand) &&
              familyMatches &&
              this.modelsAreCompatible(name, gun.name)
            );
          })
          .flatMap((gun) => gun.products);
        return [...new Map(products.map((product) => [product.h, product])).values()];
      }

      renderGunSuggestions(query) {
        const ranked = this.guns
          .map((gun) => ({ ...gun, score: this.score(query, gun.name) }))
          .filter((gun) => (query ? gun.score > 0 && this.modelsAreCompatible(query, gun.name) : true))
          .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name))
          .slice(0, query ? 8 : this.guns.length);
        this.gunSuggestions.innerHTML = ranked
          .map(
            (gun) => {
              const productCount = this.productsForGunSelection(gun.name).length;
              return `
              <button class="eyv-finder__suggestion" type="button" role="option"
                data-action="select-gun" data-value="${this.escape(gun.name)}">
                <strong>${this.escape(gun.name)}</strong>
                <small>${productCount} matching holster option${productCount === 1 ? '' : 's'} in catalog</small>
              </button>`;
            }
          )
          .join('');
        this.gunSuggestions.classList.toggle('is-open', ranked.length > 0 && (query.length > 0 || document.activeElement === this.gunInput));
      }

      switchMode(mode) {
        this.querySelectorAll('[data-mode-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.modePanel !== mode;
        });
        this.querySelectorAll('[data-action="switch-mode"]').forEach((button) => {
          const active = button.dataset.mode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
        if (mode === 'chat' && !this.querySelector('[data-complete-entry]').hidden) this.chatInput.focus();
      }

      renderGuideGunSuggestions(query) {
        const ranked = this.guns
          .map((gun) => ({ ...gun, score: this.score(query, gun.name) }))
          .filter((gun) => (query ? gun.score > 0 : true))
          .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name))
          .slice(0, query ? 8 : this.guns.length);
        this.guideGunSuggestions.innerHTML = ranked
          .map((gun) => {
            const productCount = this.productsForGunSelection(gun.name).length;
            return `
              <button class="eyv-finder__suggestion" type="button" role="option"
                data-action="guide-select-gun" data-value="${this.escape(gun.name)}">
                <strong>${this.escape(gun.name)}</strong>
                <small>${productCount} compatible holster option${productCount === 1 ? '' : 's'}</small>
              </button>`;
          })
          .join('');
        this.guideGunSuggestions.classList.toggle(
          'is-open',
          ranked.length > 0 && (query.length > 0 || document.activeElement === this.guideGunInput)
        );
      }

      guideSelectGun(name) {
        const gun = this.guns.find((item) => item.name === name);
        if (!gun) return;
        const genericFamily = this.genericFamilySelection(this.guideGunInput.value);
        this.chatState.gun = genericFamily ? genericFamily.label : gun.name;
        this.chatState.gunProducts = genericFamily
          ? this.productsForGenericFamily(genericFamily)
          : this.productsForGunSelection(gun.name);
        this.guideGunInput.value = this.chatState.gun;
        this.guideGunSuggestions.classList.remove('is-open');
        this.querySelector('[data-action="guide-confirm-gun"]').disabled = false;
      }

      guideConfirmGun() {
        const query = this.guideGunInput.value.trim();
        const error = this.querySelector('[data-guide-gun-error]');
        const genericFamily = this.genericFamilySelection(query);
        const candidates = this.rankConversationGuns(query);
        const hasManufacturerAndNumberedModel =
          Boolean(this.brandToken(query)) && this.modelTokens(query).length > 0;
        const clearWinner =
          Boolean(genericFamily) ||
          candidates.length === 1 ||
          (candidates[0] && candidates[0].conversationScore >= 650) ||
          (candidates[0] && candidates[1] && candidates[0].conversationScore - candidates[1].conversationScore >= 100) ||
          hasManufacturerAndNumberedModel;

        if (!query || !clearWinner || (!genericFamily && !candidates.length)) {
          error.textContent = 'We could not confidently identify that firearm. Try the manufacturer and model, such as “Springfield Hellcat Pro,” “Glock 43X,” or “SIG P365XL.”';
          error.hidden = false;
          return;
        }

        if (genericFamily) {
          this.chatState.gun = genericFamily.label;
          this.chatState.gunProducts = this.productsForGenericFamily(genericFamily);
        } else {
          this.chatState.gun = candidates[0].name;
          this.chatState.gunProducts = this.productsForGunSelection(candidates[0].name);
        }
        if (!this.chatState.gunProducts.length) {
          error.textContent = 'We could not match that firearm to the current EYV catalog. Check the manufacturer and model, then try again.';
          error.hidden = false;
          return;
        }

        error.hidden = true;
        error.textContent = '';
        this.guideGunInput.value = this.chatState.gun;
        this.querySelector('[data-guide-gun-summary]').textContent = this.chatState.gun;
        this.showGuideStep('light');
      }

      guideSelectNoLight() {
        this.chatState.light = '';
        this.chatState.lightLabel = 'No weapon light';
        this.querySelector('[data-guide-setup-summary]').textContent =
          `${this.chatState.gun} · ${this.chatState.lightLabel}`;
        this.showGuideStep('style');
      }

      guideShowLights() {
        const lights = new Map();
        this.chatState.gunProducts.forEach((product) => {
          if (!product.l) return;
          if (!lights.has(product.l)) lights.set(product.l, { value: product.l, label: product.ln, count: 0 });
          lights.get(product.l).count += 1;
        });
        const container = this.querySelector('[data-guide-lights]');
        const options = [...lights.values()].sort((a, b) => a.label.localeCompare(b.label));
        container.innerHTML = options.length
          ? `<p>Select your exact weapon light:</p>${options
              .map(
                (light) =>
                  `<button type="button" data-action="guide-select-light" data-value="${this.escape(light.value)}" data-label="${this.escape(light.label)}"><strong>${this.escape(light.label)}</strong><small>${light.count} compatible option${light.count === 1 ? '' : 's'}</small></button>`
              )
              .join('')}`
          : '<p>No light-bearing holsters are currently listed for this firearm. Select “No weapon light” or change the firearm.</p>';
        container.hidden = false;
      }

      guideSelectLight(value, label) {
        this.chatState.light = value;
        this.chatState.lightLabel = label;
        this.querySelector('[data-guide-setup-summary]').textContent = `${this.chatState.gun} · ${label}`;
        this.showGuideStep('style');
      }

      guideShowResults(style) {
        this.chatState.style = style || 'all';
        this.chatShowResults();
      }

      showGuideStep(name) {
        this.querySelectorAll('[data-guide-step]').forEach((step) => {
          step.classList.toggle('is-active', step.dataset.guideStep === name);
        });
        const index = { gun: 1, light: 2, style: 3 }[name] || 1;
        this.querySelectorAll('[data-guide-progress] span').forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex + 1 === index);
          item.classList.toggle('is-complete', itemIndex + 1 < index);
        });
        if (name !== 'light') this.querySelector('[data-guide-lights]').hidden = true;
        if (name === 'gun') requestAnimationFrame(() => this.guideGunInput.focus());
      }

      conversationGunScore(message, gun) {
        if (!this.modelsAreCompatible(message, gun.name)) return 0;
        const messageNormalized = this.normalize(message);
        const gunNormalized = this.normalize(gun.name);
        if (messageNormalized.includes(gunNormalized)) return 1200;

        const messageModels = this.modelTokens(message);
        const gunModels = this.modelTokens(gun.name);
        const matchingModels = messageModels.filter((model) => gunModels.includes(model));
        const messageBrand = this.brandToken(message);
        const gunBrand = this.brandToken(gun.name);
        if (messageModels.length && gunModels.length && matchingModels.length) {
          return 850 + matchingModels.length * 20 + (messageBrand && messageBrand === gunBrand ? 30 : 0);
        }

        const stopWords = new Set(['i', 'have', 'a', 'an', 'the', 'with', 'without', 'for', 'want', 'need', 'holster', 'light']);
        const gunWords = gunNormalized.split(' ').filter((word) => word.length > 1 && !stopWords.has(word));
        const matchedWords = gunWords.filter((word) => messageNormalized.split(' ').includes(word));
        if (matchedWords.length >= Math.min(2, gunWords.length)) return 650 + matchedWords.length * 15;
        if (messageBrand && gunBrand && messageBrand === gunBrand) return 400;
        return 0;
      }

      rankConversationGuns(message) {
        return this.guns
          .map((gun) => ({ ...gun, conversationScore: this.conversationGunScore(message, gun) }))
          .filter((gun) => gun.conversationScore > 0)
          .sort((a, b) => b.conversationScore - a.conversationScore || b.products.length - a.products.length)
          .slice(0, 8);
      }

      detectChatStyle(message) {
        const normalized = this.normalize(message);
        if (/\b(sidecar|mag carrier|magazine carrier)\b/.test(normalized)) return 'sidecar';
        if (/\b(owb|outside waistband|outside the waistband)\b/.test(normalized)) return 'owb';
        if (/\b(iwb|inside waistband|inside the waistband|concealed|concealment)\b/.test(normalized)) return 'iwb';
        return 'all';
      }

      detectChatLight(message) {
        const normalized = String(message || '')
          .toLowerCase()
          .replace(/['’]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (/\b(no light|without a light|without light|does not have a light|doesnt have a light)\b/.test(normalized)) {
          return { found: true, value: '', label: 'No weapon light' };
        }
        const rules = [
          ['streamlight-tlr-7-sub', 'Streamlight TLR-7 Sub', /\btlr\s*7\s*sub\b/],
          ['streamlight-tlr-7-hl-x', 'Streamlight TLR-7 HL-X', /\btlr\s*7\s*hl\s*x\b/],
          ['streamlight-tlr-7-a', 'Streamlight TLR-7A', /\btlr\s*7\s*a\b/],
          ['streamlight-tlr-6', 'Streamlight TLR-6', /\btlr\s*6\b/],
          ['streamlight-tlr-1', 'Streamlight TLR-1', /\btlr\s*1\b/],
          ['surefire-xsc', 'SureFire XSC', /\b(?:sure fire\s*)?xsc\b/],
          ['olight-pl-mini-2', 'Olight PL-Mini 2', /\bpl\s*mini\s*2\b/],
          ['olight-baldr-mini', 'Olight Baldr Mini', /\bbaldr\s*mini\b/],
          ['olight-pl-x', 'Olight PL-X', /\bpl\s*x\b/],
          ['sig-sauer-lima', 'SIG Sauer LIMA', /\blima\b/],
        ];
        const matched = rules.find(([, , pattern]) => pattern.test(normalized));
        if (matched) return { found: true, value: matched[0], label: matched[1] };
        if (/\btlr\s*7\b/.test(normalized)) return { found: false, ambiguous: true };
        return { found: false, ambiguous: false };
      }

      processChatMessage(message) {
        this.chatOptions.innerHTML = '';
        this.chatState.style = this.detectChatStyle(message);

        if (!this.chatState.gun) {
          const candidates = this.rankConversationGuns(message);
          if (!candidates.length) {
            this.addChatMessage('assistant', 'I could not identify an exact firearm from that description. Please include the manufacturer and model, such as “Glock 19 Gen 5” or “SIG P365XL.”');
            return;
          }
          const genericFamily = this.genericFamilySelection(message);
          if (genericFamily) {
            this.chatState.gun = genericFamily.label;
            this.chatState.gunProducts = this.productsForGenericFamily(genericFamily);
          } else {
          const hasManufacturerAndModel =
            Boolean(this.brandToken(message)) && this.modelTokens(message).length > 0;
          const clearWinner =
            candidates.length === 1 ||
            candidates[0].conversationScore >= 1100 ||
            candidates[0].conversationScore - candidates[1].conversationScore >= 100 ||
            hasManufacturerAndModel;
          if (!clearWinner) {
            this.addChatMessage('assistant', 'I found several possible firearm configurations. Which one matches yours?');
            this.chatOptions.innerHTML = candidates
              .slice(0, 6)
              .map(
                (gun) =>
                  `<button class="eyv-finder__chat-option" type="button" data-action="chat-select-gun" data-value="${this.escape(gun.name)}">${this.escape(gun.name)}</button>`
              )
              .join('');
            return;
          }
          this.chatState.gun = candidates[0].name;
          this.chatState.gunProducts = this.productsForGunSelection(candidates[0].name);
          }
        }

        const detectedLight = this.detectChatLight(message);
        if (detectedLight.found) {
          this.chatState.light = detectedLight.value;
          this.chatState.lightLabel = detectedLight.label;
          this.finishChatRecommendation();
          return;
        }

        if (detectedLight.ambiguous) {
          this.addChatMessage('assistant', `I found ${this.chatState.gun}, but “TLR-7” can mean different lights. Which exact light do you have?`);
        } else {
          this.addChatMessage('assistant', `I found ${this.chatState.gun}. Does it have a weapon light?`);
        }
        this.renderChatLightOptions();
      }

      chatSelectGun(name) {
        const gun = this.guns.find((item) => item.name === name);
        if (!gun) return;
        this.chatState.gun = gun.name;
        this.chatState.gunProducts = this.productsForGunSelection(gun.name);
        this.addChatMessage('user', gun.name);
        this.addChatMessage('assistant', `Great—I’ll use ${gun.name}. Does it have a weapon light?`);
        this.renderChatLightOptions();
      }

      renderChatLightOptions() {
        const lights = new Map();
        this.chatState.gunProducts.forEach((product) => {
          if (product.l && !lights.has(product.l)) lights.set(product.l, product.ln);
        });
        const options = [
          { value: '', label: 'No weapon light' },
          ...[...lights.entries()].map(([value, label]) => ({ value, label })),
        ];
        this.chatOptions.innerHTML = options
          .map(
            (option) =>
              `<button class="eyv-finder__chat-option" type="button" data-action="chat-light" data-value="${this.escape(option.value)}" data-label="${this.escape(option.label)}">${this.escape(option.label)}</button>`
          )
          .join('');
      }

      chatSelectLight(value, label) {
        this.chatState.light = value;
        this.chatState.lightLabel = label;
        this.addChatMessage('user', label);
        this.finishChatRecommendation();
      }

      finishChatRecommendation() {
        const matches = this.chatState.gunProducts.filter((product) => {
          const lightMatches = this.chatState.light ? product.l === this.chatState.light : !product.l;
          const style = String(product.s || '').toLowerCase();
          const styleMatches =
            this.chatState.style === 'all' ||
            (this.chatState.style === 'iwb' && style.includes('iwb') && !style.includes('sidecar')) ||
            (this.chatState.style === 'owb' && style.includes('owb')) ||
            (this.chatState.style === 'sidecar' && style.includes('sidecar'));
          return lightMatches && styleMatches;
        });
        this.chatOptions.innerHTML = '';
        if (!matches.length) {
          this.addChatMessage(
            'assistant',
            `I don’t have a verified ${this.chatState.lightLabel || 'configuration'} match for ${this.chatState.gun} in that carry style. Try another option or contact EYV so we can verify the setup.`
          );
          this.chatOptions.innerHTML =
            '<button class="eyv-finder__chat-option" type="button" data-action="chat-restart">Start a new search</button>';
          return;
        }
        const styleLabel = this.chatState.style === 'all' ? 'available carry styles' : this.chatState.style.toUpperCase();
        this.addChatMessage(
          'assistant',
          `I found ${matches.length} verified EYV option${matches.length === 1 ? '' : 's'} for ${this.chatState.gun} with ${this.chatState.lightLabel}, including ${styleLabel}.`
        );
        this.chatOptions.innerHTML = `
          <button class="eyv-finder__chat-option" type="button" data-action="chat-show-results">Show ${matches.length} matching holster${matches.length === 1 ? '' : 's'}</button>
          <button class="eyv-finder__chat-option" type="button" data-action="chat-restart">Start over</button>`;
      }

      chatShowResults() {
        this.state.gun = this.chatState.gun;
        this.state.gunProducts = this.chatState.gunProducts;
        this.state.light = this.chatState.light || '';
        this.state.lightLabel = this.chatState.lightLabel;
        this.state.style = this.chatState.style;
        this.updateConfigurationSummary();
        this.classList.add('is-chat-results');
        this.switchMode('guided');
        this.showResults(this.chatState.style);
      }

      returnToChat(reset) {
        this.classList.remove('is-chat-results');
        this.switchMode('chat');
        if (reset) this.chatRestart();
      }

      chatRestart() {
        this.clearResultsState();
        this.chatState = { gun: '', gunProducts: [], light: null, lightLabel: '', style: 'all' };
        this.guideGunInput.value = '';
        this.querySelector('[data-action="guide-confirm-gun"]').disabled = true;
        this.querySelector('[data-guide-gun-error]').hidden = true;
        this.querySelector('[data-guide-gun-error]').textContent = '';
        this.querySelector('[data-guide-gun-summary]').textContent = '';
        this.querySelector('[data-guide-setup-summary]').textContent = '';
        this.querySelector('[data-guide-lights]').hidden = true;
        this.showGuideStep('gun');
        this.chatOptions.innerHTML = '';
        this.chatLog.innerHTML = `
          <div class="eyv-finder__message eyv-finder__message--assistant">
            <strong>EYV:</strong>
            <p>Describe your firearm, weapon light, and preferred carry style.</p>
            <p class="eyv-finder__message-example">Example: “I have a SIG P365XL with a TLR-7 Sub and want a comfortable IWB holster.”</p>
          </div>`;
        this.querySelector('[data-starter-prompts]').classList.remove('is-hidden');
      }

      addChatMessage(role, message) {
        const item = document.createElement('div');
        item.className = `eyv-finder__message eyv-finder__message--${role}`;
        item.innerHTML = `<strong>${role === 'assistant' ? 'EYV' : 'You'}:</strong><p>${this.escape(message)}</p>`;
        this.chatLog.appendChild(item);
        this.chatLog.scrollTop = this.chatLog.scrollHeight;
      }

      selectGun(name) {
        const gun = this.guns.find((item) => item.name === name);
        if (!gun) return;
        const genericFamily = this.genericFamilySelection(this.gunInput.value);
        this.state.gun = genericFamily ? genericFamily.label : gun.name;
        this.state.gunProducts = genericFamily
          ? this.productsForGenericFamily(genericFamily)
          : this.productsForGunSelection(gun.name);
        this.gunInput.value = this.state.gun;
        this.gunSuggestions.classList.remove('is-open');
        this.querySelector('[data-action="confirm-gun"]').disabled = false;
        this.clearNotice();
      }

      confirmGun() {
        if (!this.state.gun) return;
        this.querySelector('[data-summary="gun"]').textContent = this.state.gun;
        this.showStep('light', true);
      }

      selectNoLight() {
        const matches = this.state.gunProducts.filter((product) => !product.l);
        this.state.light = '';
        this.state.lightLabel = 'No weapon light';
        if (!matches.length) {
          this.showNotice(`We do not currently have a no-light product listed for ${this.state.gun}. You can still check the available styles or go back and verify the model.`);
        } else {
          this.clearNotice();
        }
        this.updateConfigurationSummary();
        this.showStep('style', true);
      }

      showLightStep() {
        const lights = this.availableLights();
        if (!lights.length) {
          this.showNotice(`No light-bearing holster is currently listed for ${this.state.gun}.`);
          return;
        }
        this.lightInput.value = '';
        this.state.light = '';
        this.state.lightLabel = '';
        this.querySelector('[data-action="confirm-light"]').disabled = true;
        this.showStep('light-model', true);
        this.renderLightSuggestions('');
        this.lightInput.focus();
      }

      availableLights() {
        const lights = new Map();
        this.state.gunProducts.forEach((product) => {
          if (product.l && !lights.has(product.l)) {
            lights.set(product.l, { value: product.l, label: product.ln, count: 0 });
          }
          if (product.l) lights.get(product.l).count += 1;
        });
        return [...lights.values()];
      }

      renderLightSuggestions(query) {
        const ranked = this.availableLights()
          .map((light) => ({ ...light, score: this.score(query, light.label) }))
          .filter((light) => (query ? light.score > 0 : true))
          .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label));
        this.lightSuggestions.innerHTML = ranked
          .map(
            (light) => `
              <button class="eyv-finder__suggestion" type="button" role="option"
                data-action="select-light" data-value="${this.escape(light.value)}" data-label="${this.escape(light.label)}">
                <strong>${this.escape(light.label)}</strong>
                <small>${light.count} matching holster option${light.count === 1 ? '' : 's'}</small>
              </button>`
          )
          .join('');
        this.lightSuggestions.classList.toggle('is-open', ranked.length > 0);
      }

      selectLight(value, label) {
        this.state.light = value;
        this.state.lightLabel = label;
        this.lightInput.value = label;
        this.lightSuggestions.classList.remove('is-open');
        this.querySelector('[data-action="confirm-light"]').disabled = false;
        this.clearNotice();
      }

      confirmLight() {
        if (!this.state.light) return;
        this.updateConfigurationSummary();
        this.showStep('style', true);
      }

      updateConfigurationSummary() {
        const summary = `${this.state.gun} · ${this.state.lightLabel}`;
        this.querySelector('[data-summary="configuration"]').textContent = summary;
        this.querySelector('[data-summary="results"]').textContent = summary;
      }

      showResults(style) {
        this.state.style = style || 'all';
        this.state.collection = 'all';
        this.querySelector('[data-collection-filter]').value = 'all';
        this.showStep('results', true);
        this.renderResults();
      }

      filteredResults() {
        return this.state.gunProducts.filter((product) => {
          const lightMatches = this.state.light ? product.l === this.state.light : !product.l;
          const styleValue = String(product.s || '').toLowerCase();
          const styleMatches =
            this.state.style === 'all' ||
            (this.state.style === 'iwb' && styleValue.includes('iwb') && !styleValue.includes('sidecar')) ||
            (this.state.style === 'owb' && styleValue.includes('owb')) ||
            (this.state.style === 'sidecar' && styleValue.includes('sidecar'));
          const collectionMatches =
  this.state.collection === 'all' ||
  String(product.c || '').trim().toLowerCase() ===
    String(this.state.collection || '').trim().toLowerCase();
          return lightMatches && styleMatches && collectionMatches;
        });
      }

      renderResults() {
        const results = this.filteredResults();
        const grid = this.querySelector('[data-results]');
        const empty = this.querySelector('[data-empty]');
        this.querySelector('[data-result-count]').textContent = `${results.length} verified match${results.length === 1 ? '' : 'es'}`;
        grid.innerHTML = results
          .map(
            (product) => `
              <article class="eyv-finder__card">
                <a class="eyv-finder__card-image" data-eyv-product-link href="/products/${encodeURIComponent(product.h)}">
                  ${
                    product.i
                      ? `<img src="${this.escape(product.i)}&width=600" alt="${this.escape(product.t)}" loading="lazy" width="600" height="600">`
                      : ''
                  }
                </a>
                <div class="eyv-finder__card-body">
                  <a
  class="eyv-finder__card-meta eyv-finder__card-meta-link"
  data-eyv-product-link
  href="/products/${encodeURIComponent(product.h)}"
>
  ${this.escape(product.c)} · ${this.escape(product.s)}
</a>
                  <h3>
  <a
    class="eyv-finder__card-title-link"
    data-eyv-product-link
    href="/products/${encodeURIComponent(product.h)}"
  >
    ${this.escape(product.t)}
  </a>
</h3>
                  <p class="eyv-finder__card-price">From $${this.escape(product.p)}</p>
                  <a class="button button--primary" data-eyv-product-link href="/products/${encodeURIComponent(product.h)}">View Details</a>
                </div>
              </article>`
          )
          .join('');
        grid.hidden = results.length === 0;
        empty.hidden = results.length !== 0;
      }

      resultsStorageKey() {
        return `eyv-holster-finder-results:${window.location.pathname}`;
      }

      clearResultsState() {
        try {
          sessionStorage.removeItem(this.resultsStorageKey());
        } catch (error) {
          // Nothing to clear when session storage is unavailable.
        }
      }

      saveResultsState() {
        if (!this.classList.contains('is-chat-results') || !this.state.gunProducts.length) return;
        const snapshot = {
          state: {
            gun: this.state.gun,
            productHandles: this.state.gunProducts.map((product) => product.h),
            light: this.state.light,
            lightLabel: this.state.lightLabel,
            style: this.state.style,
            collection: this.state.collection,
          },
          chatState: {
            gun: this.chatState.gun,
            productHandles: this.chatState.gunProducts.map((product) => product.h),
            light: this.chatState.light,
            lightLabel: this.chatState.lightLabel,
            style: this.chatState.style,
          },
          chatLog: this.chatLog.innerHTML,
          chatOptions: this.chatOptions.innerHTML,
          scrollY: window.scrollY,
          savedAt: Date.now(),
        };
        try {
          sessionStorage.setItem(this.resultsStorageKey(), JSON.stringify(snapshot));
        } catch (error) {
          // The finder still works normally if session storage is unavailable.
        }
      }

      restoreResultsState() {
        let snapshot;
        try {
          snapshot = JSON.parse(sessionStorage.getItem(this.resultsStorageKey()) || 'null');
        } catch (error) {
          return;
        }
        if (!snapshot || !snapshot.state || Date.now() - snapshot.savedAt > 30 * 60 * 1000) return;

        const productsFromHandles = (handles) => {
          const wanted = new Set(Array.isArray(handles) ? handles : []);
          return this.catalog.filter((product) => wanted.has(product.h));
        };
        const restoredProducts = productsFromHandles(snapshot.state.productHandles);
        if (!restoredProducts.length) return;

        this.state.gun = snapshot.state.gun || '';
        this.state.gunProducts = restoredProducts;
        this.state.light = snapshot.state.light || '';
        this.state.lightLabel = snapshot.state.lightLabel || '';
        this.state.style = snapshot.state.style || 'all';
        this.state.collection = snapshot.state.collection || 'all';
        this.state.history = [];

        const savedChat = snapshot.chatState || {};
        this.chatState = {
          gun: savedChat.gun || this.state.gun,
          gunProducts: productsFromHandles(savedChat.productHandles),
          light: savedChat.light ?? this.state.light,
          lightLabel: savedChat.lightLabel || this.state.lightLabel,
          style: savedChat.style || this.state.style,
        };
        if (!this.chatState.gunProducts.length) this.chatState.gunProducts = restoredProducts;
        if (snapshot.chatLog) this.chatLog.innerHTML = snapshot.chatLog;
        if (snapshot.chatOptions) this.chatOptions.innerHTML = snapshot.chatOptions;

        this.updateConfigurationSummary();
        this.classList.add('is-chat-results');
        this.switchMode('guided');
        this.querySelector('[data-collection-filter]').value = this.state.collection;
        this.showStep('results', false);
        this.renderResults();

        const restoredScrollY = Number(snapshot.scrollY) || 0;
        requestAnimationFrame(() => window.scrollTo(0, restoredScrollY));
      }

      showStep(name, addHistory) {
        const current = this.querySelector('.eyv-finder__step.is-active');
        const currentName = current ? current.dataset.step : '';
        if (addHistory && currentName) this.state.history.push(currentName);
        this.querySelectorAll('.eyv-finder__step').forEach((step) => {
          step.classList.toggle('is-active', step.dataset.step === name);
        });
        const progressIndex = { gun: 1, light: 2, 'light-model': 2, style: 3, results: 4 }[name] || 1;
        this.querySelectorAll('.eyv-finder__progress span').forEach((item, index) => {
          const itemIndex = index + 1;
          item.classList.toggle('is-active', itemIndex === progressIndex);
          item.classList.toggle('is-complete', itemIndex < progressIndex);
        });
        this.clearNotice();
        this.closeSuggestions();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      goBack() {
        const previous = this.state.history.pop() || 'gun';
        this.showStep(previous, false);
      }

      restart() {
        if (this.classList.contains('is-chat-results')) {
          this.returnToChat(true);
          return;
        }
        this.state.gun = '';
        this.state.gunProducts = [];
        this.state.light = '';
        this.state.lightLabel = '';
        this.state.style = 'all';
        this.state.collection = 'all';
        this.state.history = [];
        this.gunInput.value = '';
        this.lightInput.value = '';
        this.querySelector('[data-action="confirm-gun"]').disabled = true;
        this.querySelector('[data-action="confirm-light"]').disabled = true;
        this.showStep('gun', false);
        this.gunInput.focus();
      }

      showNotice(message) {
        this.notice.textContent = message;
        this.notice.classList.add('is-visible');
      }

      clearNotice() {
        this.notice.textContent = '';
        this.notice.classList.remove('is-visible');
      }

      closeSuggestions() {
        this.gunSuggestions.classList.remove('is-open');
        this.lightSuggestions.classList.remove('is-open');
        this.guideGunSuggestions.classList.remove('is-open');
      }

      escape(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }
    }
  );
}
